export default __webpack_public_path__ + "static/media/feather.0d2fae64.svg";